<template>
  <div class="menu">
    <template v-for="item in data">
      <el-submenu :key="item.moduleId" :index="`${item.moduleId}`" v-if="item.children && item.children.length > 0">
        <span slot="title">{{ item.moduleName }}</span>
        <menu-tree v-on="$listeners" :data="item.children"></menu-tree>
      </el-submenu>

      <el-menu-item :index="`${item.moduleId}`" @click="onMenuClick(item)" :key="'noson-' + item.moduleId" v-else>
        <span slot="title">{{ item.moduleName }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MenuTree',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onMenuClick(item) {
      this.$emit('menuclick', item)
    }
  }
}
</script>

<style lang="less" scoped>
.menu li:nth-child(2) ::v-deep.el-menu-item{
  font-weight: normal !important;
}
.menu .menu .menu ::v-deep .el-submenu__title{
  font-weight: normal !important;
}
.menu li:nth-child(3) ::v-deep.el-menu-item{
  font-weight: normal !important;
}
::v-deep .el-menu .el-menu-item{
  font-size: 16px;
  font-weight: bold;
}
::v-deep .el-menu .el-menu .el-submenu .el-menu-item{
  font-size: 14px;
  font-weight: normal;
}
::v-deep .el-submenu__title{
  font-size: 16px;
  font-weight: bold;
}
::v-deep .el-menu-item {
  transition: none;
}

::v-deep .el-submenu__title:focus,
.el-menu-item:focus {
  background: #FFF1F0 !important;
}

::v-deep .el-menu-item.is-active {
  background-color: #FFF1F0;
  border-right: 3px solid #E60027;
}
</style>
